const Nosotross = () => {
  return (
    <div className="px-6 py-10 max-w-7xl mx-auto">
      {/* Título principal */}
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold text-[#8B0000]">Nosotros</h1>
        <p className="text-xl text-gray-600 mt-2">20 años de excelencia</p>
      </div>

      {/* Sección 1: Historia de la empresa */}
      <div className="flex flex-col md:flex-row items-center mb-16 gap-6">
        <img
          src="/historia.jpg"
          alt="Historia de la empresa"
          className="w-full md:w-1/2 rounded-lg shadow-lg"
        />
        <div className="md:w-1/2">
          <h2 className="text-2xl font-bold text-[#8B0000] mb-4">Historia de la empresa</h2>
          <p className="text-gray-600">
            Nuestra historia comenzó hace 20 años, con una sola camioneta y el sueño de ayudar a las familias a mudarse sin estrés. Hoy somos líderes en el rubro de mudanzas en el país.
          </p>
        </div>
      </div>

      {/* Sección 2: Liderazgo */}
      <div className="flex flex-col md:flex-row-reverse items-center mb-16 gap-6">
        <img
          src="/liderazgo.jpg"
          alt="Liderazgo"
          className="w-full md:w-1/2 rounded-lg shadow-lg"
        />
        <div className="md:w-1/2">
          <h2 className="text-2xl font-bold text-[#8B0000] mb-4">Liderazgo</h2>
          <p className="text-gray-600">
            Nuestro equipo directivo está comprometido con la innovación y la mejora continua. Guiamos con el ejemplo, inspirando confianza y construyendo relaciones duraderas.
          </p>
        </div>
      </div>

      {/* Sección 3: Privacidad */}
      <div className="flex flex-col md:flex-row items-center gap-6">
        <img
          src="/privacidad.jpg"
          alt="Privacidad"
          className="w-full md:w-1/2 rounded-lg shadow-lg"
        />
        <div className="md:w-1/2">
          <h2 className="text-2xl font-bold text-[#8B0000] mb-4">Privacidad</h2>
          <p className="text-gray-600">
            Nuestro equipo está comprometido con la privacidad y protección de los bienes de nuestros clientes.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Nosotross;
